const common = {
  namespaced: true,
  state: {
    brandId: sessionStorage.getItem('brandId') || '',
    brandName: sessionStorage.getItem('brandName') || ''
  },
  mutations: {
    SET_BRAND_ID: (state, brandId) => {
      state.brandId = brandId
      sessionStorage.setItem('brandId', brandId)
    },
    SET_BRAND_NAME: (state, brandName) => {
      state.brandName = brandName
      sessionStorage.setItem('brandName', brandName)
    }
  },
  actions: {
    setBrandId({ commit }, brandId) {
      commit('SET_BRAND_ID', brandId)
    },
    setBrandName({ commit }, brandName) {
      commit('SET_BRAND_NAME', brandName)
    },
    setBrandInfo({ commit }, { brandId, brandName }) {
      commit('SET_BRAND_ID', brandId)
      commit('SET_BRAND_NAME', brandName)
    }
  }
}

export default common
